// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { tankHealthEnum } from './TankHealthEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationHealthReportId = (z.number());
export const fermentationHealthReport = z.object({
    id: fermentationHealthReportId,
    fermentation_id: fermentationId,
    health: tankHealthEnum.nullable(),
    note: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId,
});
export const fermentationHealthReportInitializer = z.object({
    id: fermentationHealthReportId.optional(),
    fermentation_id: fermentationId,
    health: tankHealthEnum.optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId,
});
export const fermentationHealthReportMutator = z.object({
    id: fermentationHealthReportId.optional(),
    fermentation_id: fermentationId.optional(),
    health: tankHealthEnum.optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional(),
});
//# sourceMappingURL=FermentationHealthReport.js.map